import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, DownIcon, UncheckIcon } from '../../../icons';

const NewCustomerForm = ({
  cncCode,
  activeTab,
  customerForm,
  customerFormValue,
  handleCustomerFormChange,
}) => {
  const { data, actions } = customerForm;
  const [isExpendded, setExpendState] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const [borderColor, setBorderColor] = useState('');
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const activeButton = customerFormValue[cncCode]
      ? customerFormValue[cncCode][data.id]
      : false;
    setActiveButton(activeButton);
    const borderColor =
      activeButton === 'rejected'
        ? 'border border-primary'
        : activeButton === 'accepted'
        ? 'border border-success'
        : '';
    setBorderColor(borderColor);
  }, [customerFormValue, cncCode, data?.id]);

  useEffect(() => {
    let vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    if (vw <= 991) {
      let slicedData = Object.fromEntries(Object.entries(data).slice(0, 4));
      setFormData(slicedData);
    } else {
      setFormData(data);
    }
  }, []);

  const handleExpendCollapse = () => {
    if (isExpendded) {
      let slicedData = Object.fromEntries(Object.entries(data).slice(0, 4));
      setFormData(slicedData);
    } else {
      setFormData(data);
    }
    setExpendState(!isExpendded);
  };

  return (
    <div
      className={`bg-white h-full p-6 rounded-xl flex flex-col gap-4 ${borderColor} ${
        activeTab === 0 && 'max-lg:hidden'
      }`}
    >
      <div className="flex flex justify-between">
        <h4>Φόρμα Νέου Πελάτη</h4>
        <button type="button" className="" onClick={handleExpendCollapse}>
          <DownIcon className={isExpendded && 'rotate-180'} />
        </button>
      </div>
      <ul className="flex flex-col lg:gap-4 gap-2">
        {Object.keys(formData).map((key) => {
          const { id, label, value } = data[key];
          if (!label) {
            return <></>;
          }
          return (
            <li
              key={id}
              className="flex max-lg:flex-col lg:justify-between flex-1"
            >
              <span className="text-body text-grenite">{label}</span>
              <span className="max-lg:font-medium max-lg:h5 h6">{value}</span>
            </li>
          );
        })}
      </ul>
      <div className="grid lg:grid-cols-2 gap-3 self-end">
        {actions.map(({ id, label, name }) => {
          return (
            <button
              key={id}
              type="button"
              className={
                activeButton === name
                  ? 'flex gap-2 items-center btn bg-black text-secondary text-primary-button'
                  : 'flex gap-2 items-center btn btn-secondary text-secondary-button'
              }
              onClick={() => handleCustomerFormChange(data.id, name)}
            >
              {name === 'rejected' && (
                <UncheckIcon
                  className={
                    activeButton === name
                      ? 'w-6 h-6 stroke-primary'
                      : 'w-6 h-6 stroke-grenite'
                  }
                />
              )}
              {name === 'accepted' && (
                <CheckCircleIcon
                  className={`${
                    activeButton === name
                      ? 'stroke-[#13EF00]'
                      : 'stroke-grenite'
                  }`}
                />
              )}
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NewCustomerForm;
